<router-outlet></router-outlet>

<app-notification></app-notification>
<app-notification-messages *ngIf="canShowNotificationMessages"></app-notification-messages>

<ng-container
    *ngIf="userRole === userRoleList.COORDINATOR || userRole === userRoleList.MANAGEMENT || userRole === userRoleList.EXECUTIVE_ADMIN"
>
    <app-notification-queue></app-notification-queue>
</ng-container>
